var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestionsRemaining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#6A3663",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12h24v24H12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.313 29.538h-13.75a.69.69 0 0 0-.688.693v1.384a.69.69 0 0 0 .688.693h13.75a.69.69 0 0 0 .687-.693v-1.384a.69.69 0 0 0-.688-.693zm0-13.846h-13.75a.69.69 0 0 0-.688.693v1.384a.69.69 0 0 0 .688.693h13.75a.69.69 0 0 0 .687-.693v-1.384a.69.69 0 0 0-.688-.693zm0 6.923h-13.75a.69.69 0 0 0-.688.693v1.384a.69.69 0 0 0 .688.693h13.75a.69.69 0 0 0 .687-.693v-1.384a.69.69 0 0 0-.688-.693zM15.063 15A2.07 2.07 0 0 0 13 17.077a2.07 2.07 0 0 0 2.063 2.077 2.07 2.07 0 0 0 2.062-2.077A2.07 2.07 0 0 0 15.062 15zm0 6.923A2.07 2.07 0 0 0 13 24a2.07 2.07 0 0 0 2.063 2.077A2.07 2.07 0 0 0 17.125 24a2.07 2.07 0 0 0-2.063-2.077zm0 6.923A2.07 2.07 0 0 0 13 30.923 2.07 2.07 0 0 0 15.063 33a2.07 2.07 0 0 0 2.062-2.077 2.07 2.07 0 0 0-2.063-2.077z",
    fill: "#FE89EE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionsRemaining);
export default __webpack_public_path__ + "static/media/icon-questions-remaining.35370477.svg";
export { ForwardRef as ReactComponent };